import * as React from "react";
import { forwardRef } from "react";
const HeartSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { d: "M13.36 2.674C11.513 1.45 9.232 2.02 8 3.422 6.77 2.02 4.488 1.442 2.64 2.674A3.7 3.7 0 0 0 1.003 5.59c-.098 2.638 2.309 4.753 5.983 7.997l.07.06c.531.47 1.35.47 1.882-.006l.077-.068c3.673-3.237 6.073-5.351 5.983-7.99a3.7 3.7 0 0 0-1.638-2.91" }));
const ForwardRef = forwardRef(HeartSVG);
export default ForwardRef;
//# sourceMappingURL=Heart.js.map